export default "__VITE_ASSET__CPWYGmox__"